import { Fragment, ReactElement } from 'react';

import { IconButton, TableCell, TableRow, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { formatDateForLocale } from '@/utils';

import { User } from '../types';
import { useBoolean } from 'usehooks-ts';
import { ManageProfileDrawer } from './ManageProfileDrawer';
import { Status } from '@/components';
import { setUserIdFilter } from '../store';

export const UsersTableRow = (props: User): ReactElement => {
  const {
    value: shouldShowManageDrawer,
    toggle: toggleManageDrawer,
    setFalse,
  } = useBoolean();

  const formattedLastActiveDate = formatDateForLocale(props.updatedAt);

  const handleEdit = () => {
    setUserIdFilter(props._id);
    toggleManageDrawer();
  };

  return (
    <Fragment>
      <TableRow>
        {/* ID */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props._id}
          </Typography>
        </TableCell>

        {/* Full name */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {`${props.firstName} ${props.lastName}`}
          </Typography>
        </TableCell>

        {/* Experience */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {/* {props.experience} */}
          </Typography>
        </TableCell>

        {/* Credit */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.creditBalance}
          </Typography>
        </TableCell>

        {/* Email */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.email}
          </Typography>
        </TableCell>

        {/* Last Active Date */}
        <TableCell>{formattedLastActiveDate}</TableCell>

        {/* Status */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {/* <Status status={props.status} useIcon /> */}
          </Typography>
        </TableCell>

        {/* Action button(s) */}
        <TableCell>
          <IconButton
            aria-label="Action Button"
            size="small"
            color="inherit"
            onClick={() => handleEdit()}
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
      <ManageProfileDrawer value={shouldShowManageDrawer} setFalse={setFalse} />
    </Fragment>
  );
};
